
export const masonryTrigger = (selector) => {

    window.addEventListener('load', () => {
        
        document.querySelectorAll(selector).forEach(el => {
        
            var msnry = new Masonry( el, {  
                itemSelector: '.teaser',
                columnWidth: '.__masonryWidth',
                percentPosition: true,
                fitWidth: true,
                gutter: 20,
                horizontalOrder: false
            });
        });
    });
}
